import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import environment from '@lib/environment';

class LogEnvModule extends AppModule {
  override preload(): void {
    this.app.events.on('app.started', () => {
      const {
        FULLSTORY_ORG_ID,
        SENTRY_DSN,
        MODE,
        AUTH_IUM_ISSUER_URL,
        AUTH_IUM_CLIENT_ID,
      } = environment;
      if (MODE !== 'production') {
        this.app.logger.info('MODE', MODE);
        this.app.logger.info('FULLSTORY_ORG_ID', FULLSTORY_ORG_ID);
        this.app.logger.info('SENTRY_DSN', SENTRY_DSN);
        this.app.logger.info('AUTH_IUM_ISSUER_URL', AUTH_IUM_ISSUER_URL);
        this.app.logger.info('AUTH_IUM_CLIENT_ID', AUTH_IUM_CLIENT_ID);
      }
    });
  }
}

export default new LogEnvModule(appManager.events, appManager.logger('Env'));
